import { useSnapshot } from 'valtio';
import { phoneState } from './state';

function usePhoneState() {
  const state = useSnapshot(phoneState);
  return state;
}

export default usePhoneState;
